import { ToggleInlineMenuButton as ToggleInlineMenuButtonCore } from "@/components/ui/editor/core/components/toggle-inline-menu-button";
import { useEditorContext } from "../rich-text-editor-provider";

export const ToggleInlineMenuButton = () => {
  const { toggleInlineMenu } = useEditorContext("Editor");
  return <ToggleInlineMenuButtonCore toggleInlineMenu={toggleInlineMenu} />;
};
